import React, { useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { ToolTip } from '@repo/common';
import { cn } from './model/derive';

/**
 * body 에 띄우는 말풍선(디자인 시스템 ToolTip) — 모달·스크롤 영역에 잘리지 않고 기준 요소 아래(자리가 없으면 위)에 붙는다.
 * 꼬리는 기준 요소 쪽(왼쪽 정렬)
 */

const GAP = 10;
const EDGE = 16;

const FloatingTip = ({ anchorRef, open, id, width = 300, className, children }) => {
  const tipRef = useRef(null);
  const [pos, setPos] = useState(null);
  const fitWidth = () =>
    Math.min(width, (typeof window === 'undefined' ? width : window.innerWidth) - EDGE * 2);

  useLayoutEffect(() => {
    if (!open) {
      setPos(null);
      return undefined;
    }
    const place = () => {
      const a = anchorRef.current?.getBoundingClientRect();
      if (!a) return;
      const w = fitWidth();
      const h = tipRef.current?.offsetHeight ?? 0;
      const left = Math.min(Math.max(EDGE, a.left), window.innerWidth - EDGE - w);
      const below = a.bottom + GAP;
      const above = a.top - GAP - h;
      const top = below + h > window.innerHeight - EDGE && above >= EDGE ? above : below;
      setPos({ left, top, width: w, above: top === above && top !== below });
    };
    place();
    window.addEventListener('scroll', place, true);
    window.addEventListener('resize', place);
    return () => {
      window.removeEventListener('scroll', place, true);
      window.removeEventListener('resize', place);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, width]);

  if (!open) return null;
  return ReactDOM.createPortal(
    <span
      id={id}
      ref={tipRef}
      role='tooltip'
      style={
        pos
          ? { left: pos.left, top: pos.top, width: pos.width }
          : { left: 0, top: 0, width: fitWidth(), visibility: 'hidden' }
      }
      className={cn('pointer-events-none fixed z-[1100]', className)}
    >
      <ToolTip
        position={pos?.above ? 'bottom' : 'top'}
        align='left'
        state='accent'
        line='multi'
        className='block'
        label={<span className='flex flex-col gap-0.5'>{children}</span>}
      />
    </span>,
    document.body,
  );
};

export default FloatingTip;
